import { Typography } from "antd";

const { Title, Paragraph } = Typography;

export const TransitionsSection = ({ title, description, children }) => {
  return (
    <div>
      <Title level={5} style={{ fontWeight: 600 }} className="text-primary">
        {title}
      </Title>
      <Paragraph style={{ marginBottom: 8 }} className="text-secondary">
        {description}
      </Paragraph>
      {children}
    </div>
  );
};
